import { render, staticRenderFns } from "./dashboardBodegaAdmin.vue?vue&type=template&id=7d1fea30&scoped=true"
import script from "./dashboardBodegaAdmin.vue?vue&type=script&lang=js"
export * from "./dashboardBodegaAdmin.vue?vue&type=script&lang=js"
import style0 from "./dashboardBodegaAdmin.vue?vue&type=style&index=0&id=7d1fea30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1fea30",
  null
  
)

export default component.exports